import { BASE_URL } from 'constant';
import privateFetch, { privateFetchFormData } from 'PrivateFetch';

const URL_API = BASE_URL + 'beritaAcara/';

export const LOADING_BA_MASTER_LIST = 'LOADING_BA_MASTER_LIST';
export const SUCCESS_BA_MASTER_LIST = 'SUCCESS_BA_MASTER_LIST';
export const ERROR_BA_MASTER_LIST = 'ERROR_BA_MASTER_LIST';
export const LOADING_BA_LIST = 'LOADING_BA_LIST';
export const SUCCESS_BA_LIST = 'SUCCESS_BA_LIST';
export const ERROR_BA_LIST = 'ERROR_BA_LIST';
export const LOADING_ACTION_BA = 'LOADING_ACTION_BA';
export const SUCCESS_ACTION_BA = 'SUCCESS_ACTION_BA';
export const ERROR_ACTION_BA = 'ERROR_ACTION_BA';


const loadingBAMasterList = bool => {
    return {
        type: LOADING_BA_MASTER_LIST,
        loading: bool
    }
}

const successBAMasterList = (bool, data) => {
    return {
        type: SUCCESS_BA_MASTER_LIST,
        success: bool,
        data
    }
}

const errorBAMasterList = (bool, data) => {
    return {
        type: ERROR_BA_MASTER_LIST,
        error: bool,
        data
    }
}

const loadingBAList = bool => {
    return {
        type: LOADING_BA_LIST,
        loading: bool
    }
}

const successBAList = (bool, data) => {
    return {
        type: SUCCESS_BA_LIST,
        success: bool,
        data
    }
}

const errorBAList = (bool, data) => {
    return {
        type: ERROR_BA_LIST,
        error: bool,
        data
    }
}

const loadingActionBA = bool => {
    return {
        type: LOADING_ACTION_BA,
        loading: bool
    }
}

const successActionBA = (bool, data) => {
    return {
        type: SUCCESS_ACTION_BA,
        success: bool,
        data
    }
}

const errorActionBA = (bool, data) => {
    return {
        type: ERROR_ACTION_BA,
        error: bool,
        data
    }
}

export function getBAMaster(data) {
    let url = URL_API + 'masterList';
    return privateFetch(successBAMasterList, errorBAMasterList, loadingBAMasterList, 'POST', url, data);
}

export function getBeritaAcara(data) {
    let url = URL_API + 'page';
    return privateFetch(successBAList, errorBAList, loadingBAList, 'POST', url, data);
}

export function actionBA(data) {
    let url = URL_API;
    if (data.id) {
        url += 'update';
    } else {
        url += 'save';
    }
    return privateFetchFormData(successActionBA, errorActionBA, loadingActionBA, 'POST', url, data);
}